const FILTERS = {
    "storage-certification": {
        sc_product: {
            title: 'Platform',
            icon: 'server.png'
        },
        protocol: {
            title: 'Protocol',
            iconClass: 'network-wired'
        },        
        array_customer_version: {
            title: 'Storage',
            icon: 'array.png'
        },        
        partner: {
            title: 'Partner',
            icon: 'os.png'
        },
        certification: {
            title: 'Certification',
            icon: 'os_kernel.png'
        },
        multipath_software: {
            title: 'Multipath Software',
            icon: 'multipath.png'
        }
    }
}
export default FILTERS;